export default {
  title01: "Тренутно време",
  title02: "24 часа",
  title03: "Погледај 10-дневну прогнозу",
  title04: "AQI",
  title05: "Погледај све информације",
  title06: "ИЗЛАЗАК И ЗАЛАЗАК СУНЦА",
  title07: "ФАЗА МЕСЕЦА",
  title08: "Следећи пун Месец",
  title09: "Следећи млади Месец",
  title10: "ДАН",
  title11: "НОЋ",
  title12: "Излазак Сунца",
  title13: "Залазак Сунца",
  title14: "Излазак Месеца",
  title15: "Залазак Месеца",
  title16: "Извор",
  title17: "Почетак",
  title18: "Крај",
  title19: "Користи тренутну локацију",
  title20: "Претражи град",
  title21: "Осећа се као",
  title22: "Осећа се као у сенци",
  title23: "Сада",
  title24: "Данас",
  title25: "НЕД",
  title26: "ПОН",
  title27: "УТО",
  title28: "СРЕ",
  title29: "ЧЕТ",
  title30: "ПЕТ",
  title31: "СУБ",
  title32: "Учитавање...",
  title33: "Сада",
  title34: "На сат времена",
  title35: "Дан",
  title36: "Сунце и Месец",
  title37: "Квалитет ваздуха",
  title38: "Контакт: xlf550402@gmail.com",
  title39: "Политика приватности",
  title40: "Ауторска права © comfortweather.com 2020 - 2024. Сва права задржана.",
  title41: "Подаци обезбеђени од стране",
  title42: "Maks",
  title43: "Min",
  title44: "Прихватам",
  title45:
    "Хвала вам што користите ComfortWeather! Да бисте боље заштитили своја законска права и интересе, молимо вас да пажљиво прочитате ",
  title46: "Политику приватности",
  title47: " пре употребе.",
  title48: "",
  title49: "Контакт: xyjph123@gmail.com",
  title50: "Ауторска права © 24hweather.com 2020 - 2024. Сва права задржана.",
  title51:
    "Хвала вам што користите 24hweather! Да бисте боље заштитили своја законска права и интересе, молимо вас да пажљиво прочитате ",
};
